import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f2410c86&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=f2410c86&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=f2410c86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2410c86",
  null
  
)

export default component.exports